import React from 'react';

/**
 * Error Boundary pour capturer les erreurs de chargement de chunks React
 * Affiche une page offline avec message et bouton de rechargement
 */
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      isChunkError: false
    };
  }

  static getDerivedStateFromError(error) {
    // Détecter les erreurs de chargement de chunks
    const isChunkError = 
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module');
    
    return { 
      hasError: true,
      isChunkError
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ChunkErrorBoundary] Erreur capturée:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError && this.state.isChunkError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius: '20px',
            padding: '40px',
            maxWidth: '500px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>
              📡
            </div>
            <h1 style={{ 
              fontSize: '28px', 
              marginBottom: '16px',
              fontWeight: '600'
            }}>
              Mode Hors Ligne
            </h1>
            <p style={{ 
              fontSize: '16px', 
              marginBottom: '24px',
              opacity: 0.9,
              lineHeight: '1.6'
            }}>
              Cette page n’est pas disponible hors ligne car elle n’a pas encore été visitée.
            </p>
            <p style={{ 
              fontSize: '14px', 
              marginBottom: '32px',
              opacity: 0.8
            }}>
              Reconnectez-vous à Internet pour accéder à cette page.
            </p>
            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button
                onClick={this.handleReload}
                style={{
                  background: 'white',
                  color: '#667eea',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                }}
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                onFocus={(e) => e.target.style.transform = 'scale(1.05)'}
                onBlur={(e) => e.target.style.transform = 'scale(1)'}
              >
                🔄 Réessayer
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  border: '2px solid white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s'
                }}
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                onFocus={(e) => e.target.style.transform = 'scale(1.05)'}
                onBlur={(e) => e.target.style.transform = 'scale(1)'}
              >
                🏠 Accueil
              </button>
            </div>
            <p style={{ 
              fontSize: '12px', 
              marginTop: '24px',
              opacity: 0.7
            }}>
              💡 Astuce : Visitez les pages en ligne pour les rendre disponibles hors ligne
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
